import { useStores } from "./useStores";

export function useOrganizationStore() {
  const { organizationStore } = useStores();
  return organizationStore;
}
